<template>
  <section id="formsButton" class="container mx-auto border-t-2 mt-6">
    <!-- Codigo de descarga -->
    <div
      id="formFolio"
      class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124"
    >
      <div class="title uppercase text-center font-bold">
        {{ $t("Forms.remember_buy") }}
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(submit)"
          class="flex flex-col w-full py-4 md:px-4"
        >
          <div class="flex items-end flex-wrap">
            <div class="flex flex-col flex-none md:flex-auto w-full md:w-auto">
              <ValidationProvider
                :name="$tc('Forms.download_code')"
                rules="required|min:12|max:12"
                v-slot="{ errors }"
              >
                <input
                  type="text"
                  v-model="GetPhotos.JoinedCode"
                  :maxlength="12"
                  @keyup="UpperCase($event)"
                  @input="
                    GetPhotos.JoinedCode = GetPhotos.JoinedCode.toUpperCase()
                  "
                  :placeholder="$tc('Forms.download_code')"
                  class="
                    w-full
                    h-10
                    p-3
                    my-2
                    border border-newxcaret-blue
                    bg-white
                    rounded-lg
                  "
                />
                <!-- <span>{{ errors[0] }}</span> -->
                <p class="txt-error text-red text-xs italic">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <p class="txt-error text-red text-xs italic" v-if="msgApi.error">
                {{ msgApi.message }}
              </p>
            </div>
          </div>

          <button
            type="submit"
            class="
              w-full
              flex
              justify-center
              rounded-full
              py-3
              px-4
              mb-1
              mt-4
              bg-red-500
              text-white
              cursor-pointer
              font-semibold
              mx-auto
            "
            id="formDownloadCode"
          >
            {{ $t("Forms.add_download_code") }}
          </button>
        </form>
      </ValidationObserver>
    </div>
    <!-- {{ $t('Forms.login_account') }} -->
  </section>
</template>

<script>
import "../validators/index";

import AlbumsByDownloadCodeMix from "../mixins/albums/GetAlbumsByDownloadCode";
import methodUser from "../mixins/methodUser";
import Multimedia from "../mixins/Multimedia";
import EventBus from "../EventBus.js";

export default {
  props: ["redirect", "code"],
  mixins: [AlbumsByDownloadCodeMix, methodUser, Multimedia],
  components: {},
  data: () => ({
    firstName: "",
    lastName: "",
    email: "",
    errors: [],
    downloadCodes: [],
    option: 0,
    loading: false,
    screenLoading: false,
    lastInsertItem: [],
    GetPhotos: {
      question: "",
      JoinedCode: "",
      ParkID: null,
      visitDate: "",
      tag: "",
      HotelID: null,
      Room: "",
      ArrivalDate: "",
      DepartureDate: "",
    },
    Parks: [{ value: null, text: "Seleccione una opción" }],
    Hotels: [{ value: null, text: "Seleccione una opción" }],
  }),
  computed: {
    GetParks() {
      return this.$store.getters.GetParks;
    }
  },
  methods: {
    async submit() {
      this.downloadCode(this.GetPhotos.JoinedCode);
    },
    saveDownloadCode(data) {
      let newCodes;
      let currentCode = "";
      let recoveredData = this.getAlbumes;

      if (this.GetPhotos.question == 1) {
        currentCode = this.GetPhotos.tag;
        newCodes = {
          code: this.GetPhotos.tag,
          type: this.GetPhotos.question,
          visitDate: this.GetPhotos.visitDate,
          ParkID: this.GetPhotos.ParkID,
        };
      } else if (this.GetPhotos.question == 2) {
        currentCode = this.GetPhotos.Room;
        newCodes = {
          code: this.GetPhotos.Room,
          type: this.GetPhotos.question,
          ArrivalDate: this.GetPhotos.ArrivalDate,
          DepartureDate: this.GetPhotos.DepartureDate,
          ParkID: this.GetPhotos.HotelID,
        };
      } else {
        currentCode = this.GetPhotos.JoinedCode;
        newCodes = {
          code: this.GetPhotos.JoinedCode,
          type: this.GetPhotos.question,
        };
      }

      if (recoveredData == null || !recoveredData.length) {
        this.setCodes(newCodes);
        this.GetPhotos.JoinedCode = "";
        return false;
      } else {

        //Asegurate que lo que guardes es realmente un array.
        if (!this.existCode(recoveredData, currentCode)) {
          this.setCodes(newCodes);
          this.GetPhotos.JoinedCode = "";

          return false;
        } else {
          return true;
        }
      }
    },
    existCode(data, valueFind) {
      let exist = false;
      data.map(function (item) {
        if (item.code == valueFind) exist = true;
      });

      return exist;
    },
    onChangeQuestion(event) {},
    // Metodos para agregar los codigos a un arreglo.
    addDownloadCode() {
      this.downloadCodes.push(this.GetPhotos.JoinedCode);
      this.GetPhotos.JoinedCode = "";
    },
    clearFormSearch() {
      this.GetPhotos.JoinedCode = "";
      this.GetPhotos.ParkID = null;
      this.GetPhotos.visitDate = "";
      this.GetPhotos.tag = "";
      this.HotelID = null;
      this.Room = "";
      this.ArrivalDate = "";
      this.DepartureDate = "";
    },
  },
  created() {},
  mounted() {
    if (this.code != "") {
      this.GetPhotos.JoinedCode = this.code;
    }
  },
};
</script>
